import SavingThrowsBox from './SavingThrowsBox';

export default SavingThrowsBox;
export { SavingThrowsBox };
